/* eslint-disable jsx-a11y/anchor-is-valid */
export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="w-full h-px" aria-hidden="true"></div>
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <a
                href="#Hero"
                className="text-white font-bold text-xl"
              >
                <img src="/Svgs/Logo.svg" alt="Logo" width={140} height={40} />
              </a>
            </div>
          </div>

          <nav className="flex flex-wrap justify-center md:justify-start space-x-6">
            <a href="/games" className="hover:text-gray-300 transition-colors">
              Games
            </a>
            <a href="/about" className="hover:text-gray-300 transition-colors">
              About Us
            </a>
            <a href="/services" className="hover:text-gray-300 transition-colors">
              Services
            </a>
          </nav>

          <div className="flex space-x-4">
            <a href="#">
              <img
                src="/Svgs/Twitter.svg"
                alt="Twitter Icon"
              />
            </a>
            <a href="#">
              <img
                src="/Svgs/Instagram.svg"
                alt="Instagram Icon"
              />
            </a>
            <a href="#">
              <img
                src="/Svgs/Discord.svg"
                alt="Discord Icon"
              />
            </a>
            <a href="#">
              <img
                src="/Svgs/LinkedIn.svg"
                alt="Linkedin Icon"
              />
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-sm">
          <p>&copy; Spicy Harissa Studio 2026. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};